const SLICE_SIZE = 512;

const b64toBlob = (b64Data: string, sliceSize: number, contentType?: string) => {
  contentType = contentType || '';
  const byteCharacters = atob(b64Data);
  const byteArrays: Array<BlobPart> = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Uint8Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    byteArrays.push(byteNumbers);
  }
  return new Blob(byteArrays, { type: contentType });
};

export const downloadBase64Data = (data: string, fileName: string, contentType?: string) => {
  const blob = b64toBlob(data, SLICE_SIZE, contentType);
  downloadBlob(blob, fileName);
};

export const downloadTextData = (data: string, fileName: string, contentType?: string) => {
  // Escape unicode characters before encoding
  // https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
  downloadBase64Data(btoa(unescape(encodeURIComponent(data))), fileName, contentType);
};

export const downloadFile = async (response: Response, fileName?: string) => {
  const file = await response.text();
  if (fileName === undefined) {
    const fileNameHeader = response.headers.get('content-disposition');
    // Remove starting and trailing " from filename
    fileName = fileNameHeader?.split('filename=')[1].replace(/"/g, '');
  }
  downloadBlob(new Blob([file]), fileName);
};

export const downloadBinaryFile = async (response: Response, fileName?: string) => {
  const file = await response.blob();
  if (fileName === undefined) {
    const fileNameHeader = response.headers.get('content-disposition');
    // Remove starting and trailing " from filename
    fileName = fileNameHeader?.split('filename=')[1].replace(/"/g, '');
  }
  downloadBlob(new Blob([file]), fileName);
};

export const downloadBlob = (blob: Blob, fileName?: string) => {
  const downloadLink = document.createElement('a');
  downloadLink.href = window.URL.createObjectURL(blob);
  downloadLink.setAttribute('download', fileName || '');
  document.body.appendChild(downloadLink);
  downloadLink.click();
  downloadLink.remove();
  window.URL.revokeObjectURL(downloadLink.href);
};
